export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("loadWhistleblowerEmbedScript", () => {
    if (import.meta.browser) {
      const script = document.createElement("script");
      script.src = "https://cdn.iubenda.com/iubenda.js";
      script.defer = true;

      document.head.appendChild(script);
    }
  });
});



